// https://redux.js.org/api/store
// https://react-redux.js.org/tutorials/connect
// https://codesandbox.io/s/9on71rvnyo?file=/src/redux/reducers/todos.js
// https://codesandbox.io/s/todo-app-with-redux-forked-qks60q?file=/src/components/VisibilityFilters.js:236-245
// https://reactjs.org/docs/lifting-state-up.html
// https://earthctzn.medium.com/a-react-redux-state-demo-f6846d44b069
// https://github.com/reduxjs/redux-devtools
// https://github.com/reduxjs/redux-devtools/tree/main/extension#installation

import { Fragment, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setShowNav, setPageName } from "../redux/actions";
import { NAV_STATES } from "../system/constants";

import { goPage } from "../system/coords";

// Logo
const logoASCIIMP = () => {
  // "mp" only - logo 10 x 6 (9 x 5)
  let logo = `
 # ## ### 
# # # #  #
# # # #  #
# # # ### 
      #   
      #   
`;

  return logo.replaceAll(/^\n|\n$/g, "");
};

// Block within logo
const BlockMP = ({ id, left, top, className }) => {
  const stylesObj = {
    left: `${left}px`,
    top: `${top}px`,
  };

  // Each block has an ID, className and styles to set position
  return (
    <>
      <div id={id} className={className} style={stylesObj}></div>
    </>
  );
};

const LogoMP = () => {
  const logoData = logoASCIIMP();

  // Build up an array of arrays, each containing the x, y position and if it's a block or blank
  const pos = [0, 0];
  const grid = [];
  for (const logoCharacter of logoData) {
    // Line break, set x to 0 and y to next line
    if ("\n" === logoCharacter) {
      pos[0] = 0;
      pos[1]++;
      // Push the block or blank into grid array, move onto next x position
    } else {
      grid.push([pos[0], pos[1], "#" === logoCharacter ? "block" : "blank"]);
      pos[0]++;
    }
  }

  // Return the grid, with each array item mapped to a Block function
  return grid.map(elem => {
    const id = `logoBlockMP:${elem[0]}.${elem[1]}`;
    const left = elem[0] * 7;
    const top = elem[1] * 7;
    const className = elem[2];

    // Return each child item as a fragment with unique key
    return (
      <Fragment key={id}>
        <BlockMP id={id} left={left} top={top} className={className} />
      </Fragment>
    );
  });
};

const NavMenuIcon = ({ currentState, visState }) => {
  const navClass = `nav-lines nav-menu-icon-${currentState}`;
  const mpClass = `mp-menu-icon mp-menu-icon-${currentState}`;
  const dispatch = useDispatch();

  const handleMouseEnter = useCallback(() => {
    // Only show on hover if not a touch device (desktop only)
    if (!("ontouchstart" in window)) {
      dispatch(setShowNav(visState));
    }
  }, [dispatch, visState]);

  const handleMenuToggle = useCallback(
    e => {
      // Toggle menu on mobile (clicking the 3 lines)
      e.stopPropagation(); // Prevent event bubbling
      dispatch(setShowNav(currentState === "show" ? NAV_STATES.HIDE : visState));
    },
    [dispatch, currentState, visState],
  );

  // Memoized handler for Home navigation click
  const handleHomeClick = useCallback(() => {
    goPage("Home");
    dispatch(setPageName("Home"));
    dispatch(setShowNav("hide"));
  }, [dispatch]);

  return (
    <>
      <div className={navClass} onMouseEnter={handleMouseEnter} onClick={handleMenuToggle}>
        <div className="line" id="nav-line-1" style={{ left: currentState === "show" ? "-20px" : "0" }}></div>
        <div className="line" id="nav-line-2" style={{ left: currentState === "show" ? "-10px" : "0" }}></div>
        <div className="line" id="nav-line-3"></div>
      </div>
      <div className={mpClass} onClick={handleHomeClick}>
        <LogoMP />
      </div>
    </>
  );
};

// Nav
const NavOptions = () => {
  const dispatch = useDispatch();
  const currentState = useSelector(state => state.navReducer);
  const currentPage = useSelector(state => state.pageReducer);
  const visState = NAV_STATES.SHOW;

  // Memoized handler for navigation clicks
  const handleNavClick = useCallback(
    pageName => {
      goPage(pageName);
      dispatch(setPageName(pageName));
      dispatch(setShowNav("hide"));
    },
    [dispatch],
  );

  return (
    <>
      <nav className="Nav">
        <NavMenuIcon currentState={currentState} visState={visState} />

        <div className={`Nav ${currentState}`}>
          <ul>
            <li className={currentPage === "About" ? "Nav-Current" : ""} onClick={() => handleNavClick("About")}>
              About
            </li>
            <br />
            <li className={currentPage === "Clients" ? "Nav-Current" : ""} onClick={() => handleNavClick("Clients")}>
              Clients
            </li>
            <br />
            <li className={currentPage === "Tech" ? "Nav-Current" : ""} onClick={() => handleNavClick("Tech")}>
              Tech
            </li>
            <br />
            <li className={currentPage === "Showcase" ? "Nav-Current" : ""} onClick={() => handleNavClick("Showcase")}>
              Showcase
            </li>
            <br />
            <li className={currentPage === "Demos" ? "Nav-Current" : ""} onClick={() => handleNavClick("Demos")}>
              Demos
            </li>
            <br />
            <li className={currentPage === "Contact" ? "Nav-Current" : ""} onClick={() => handleNavClick("Contact")}>
              Contact
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default NavOptions;
